import { DefaultDetailContext } from 'src/app/controls/forms/default-detail-context';
import { IProcessDefinition } from 'src/app/models/interfaces/process-definition.interface';

export class ProcessDefinitionDetailContext extends DefaultDetailContext<IProcessDefinition, number> {}
